import React from 'react';
import { StyledButton, ButtonProps } from './styles';

export const Button: React.FC<ButtonProps> = ({ children, ...rest }: ButtonProps) => {
  return <StyledButton {...rest}>{children}</StyledButton>;
};
